import React from 'react';

const PersistentFooter = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-10 bg-gradient-to-t from-black/80 to-transparent pointer-events-none">
      {/* Footer content removed - branding moved to bottom right */}
    </div>
  );
};

export default PersistentFooter;